export default {
  name: 'old',
  path: '/?type',
  i18n: ['trading-desk/flight'],
  loadComponent: () => import('./index')
};
